<template>
  <Base :base-id="'lb-add2cart-success'">
    <template #body>
      <h4 id="modal-title" class="modal-title">成功加入購物車</h4>
    </template>
  </Base>
</template>

<script setup>
import { onMounted, nextTick } from 'vue';
import Base from '@global/components/common/modal/Base.vue';

onMounted(() => {
  if (window.contextCustom.shopContentPage?.custom) {
    nextTick(() => {
      $('#lb-add2cart-success .modal-dialog .modal-content').css(
        'background',
        `url(${window.contextCustom.shopContentPage.productAddedCartImageUrl})`,
      );
    });
  }

  if (window.contextCustom.cartPage?.custom) {
    nextTick(() => {
      $('#lb-add2cart-success .modal-dialog .modal-content').css(
        'background',
        `url(${window.contextCustom.cartPage.productAddedCartImageUrl})`,
      );
    });
  }
});
</script>
